// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_7y-0";
export var optionCard = "_7y-1";